<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew"></div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-2 text-white">Portifólio</h1>
                <span class="text-white"
                  >Veja aqui alguns dos projetos que eu participei ou desenvolvi
                  do zero!</span
                >
                <br />
                <br />
                <br />
                <br />
                <!-- <p class="lead text-white">
                  The design system comes with four pre-built pages to help you
                  get started faster. You can change the text and images and
                  you're good to go.
                </p> -->
                <!-- <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                    class="mb-3 mb-sm-0"
                    type="info"
                    icon="fa fa-code"
                  >
                    Components
                  </base-button>
                  <base-button
                    tag="a"
                    href="https://www.creative-tim.com/product/argon-design-system"
                    class="mb-3 mb-sm-0"
                    type="white"
                    icon="ni ni-cloud-download-95"
                  >
                    Download HTML
                  </base-button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <!-- habilidades -->
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Nodejs</h6>
                  <p class="description mt-3">
                    A maior parte da minha experiência é em Nodejs, essa
                    ferramenta incrível permite criar APIs para o gerenciamento
                    de sites e sistemas
                  </p>
                  <div>
                    <badge type="primary" rounded>Express</badge>
                    <badge type="primary" rounded>API</badge>
                    <badge type="primary" rounded>CRUD</badge>
                  </div>
                  <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                    Learn more
                  </base-button> -->
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-istanbul"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Vuejs</h6>
                  <p class="description mt-3">
                    Vuejs juntamente com Vuetify e Bootstrap tem se mostrado um
                    conjunto poderoso na criação de softwares, desde sites
                    comuns a sistemas complexos
                  </p>
                  <div>
                    <badge type="success" rounded>Web</badge>
                    <badge type="success" rounded>Responsividade</badge>
                    <badge type="success" rounded>Ágil</badge>
                  </div>
                  <!-- <base-button tag="a" href="#" type="success" class="mt-4">
                    Learn more
                  </base-button> -->
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">
                    PostgreSQL/MySQL/MongoDB
                  </h6>
                  <p class="description mt-3">
                    Experiência com base de dados nunca é demais! Dentre as
                    bases que já trabalhei o PostgreSQL está entre minhas
                    favoritas sem dúvidas!
                  </p>
                  <div>
                    <badge type="warning" rounded>database</badge>
                    <badge type="warning" rounded>SQL</badge>
                    <badge type="warning" rounded>knex</badge>
                  </div>
                  <!-- <base-button tag="a" href="#" type="warning" class="mt-4">
                    Learn more
                  </base-button> -->
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- projeto 1 -->
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-2 bg-gradient-success shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img
              src="@/assets/images/quickblue.png"
              class="img-fluid floating"
            />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5 text-white"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3 class="text-white">Projeto do meu estágio</h3>
              <p class="text-white">
                Este projeto foi desenvolvido por mim para uma empresa que
                realiza prestação de serviço mediante contrato com o cliente.
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-th"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Cadastro de clientes e contratos
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-usd"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Controle de receitas e despesas
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-phone"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Controle de atendimentos aos clientes
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file-o"
                    ></badge>
                    <h6 class="mb-0 text-white">Emissão de NFS-e</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section my-0">
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="@/assets/images/nfse.png" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="fa fa-file-o"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3 class="">Emissão NFS-e</h3>
              <p class="">
                O projeto conta com uma API dedicada para emissão de Notas
                Fiscais de Serviço Eletrônicas na prefeitura de Presidente
                Prudente. Você pode checar o projeto no meu GitHub!
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file"
                    ></badge>
                    <h6 class="mb-0">Gerar Notas Fiscais</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-usd"
                    ></badge>
                    <h6 class="mb-0">Consultar Nota fiscal</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file-pdf-o"
                    ></badge>
                    <h6 class="mb-0">Emitir PDF da nota</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-envelope"
                    ></badge>
                    <h6 class="mb-0">Enviar NFSe por email</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <a
            href="https://github.com/makinado?tab=repositories"
            target="_blank"
          >
            <h2 class="text-success mt-5">
              Veja o projeto no meu GitHub clicando aqui
            </h2>
          </a>
        </div>
      </div>
    </section>

    <!-- documentacao -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="require('@/assets/images/documentos.jpg')"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Documentação
                </h4>
                <p class="lead text-italic text-white">
                  Todos os projetos possuem suas devidas documentações.
                  Denominada de engenharia de requisitos (ERS), visa documentar
                  o escopo, lista de funções, a viabilidade do sistema, dentre
                  outras diversas funções.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="ni ni-settings"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>

              <h3>Projetos</h3>
              <p class="lead">
                Cada projeto deve ter sua própria ERS, levando em consideração
                que cada projeto é único.
              </p>
              <p>
                A ERS serve tanto para o cliente quanto para o desenvolvedor, de
                maneira que ela deve sempre conter o contexto do sistema.
              </p>
              <p>
                A partir das telas de protótipo da ERS fica bem mais simples
                visualizar o produto que será gerado. Uma vez a ERS criada,
                pode-se dar início ao desenvolvimento do sistema.
              </p>
              <span class="font-weight-bold text-warning mt-5"
                >Sites e sistemas bonitos e bem construídos prendem o
                usuário</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- projeto 2 -->
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-warning shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img
              src="@/assets/images/sanfernando.png"
              class="img-fluid floating"
            />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3 class="text-white">Sistema para clube</h3>
              <p class="text-white">
                Este projeto foi desenvolvido por mim para um clube de campo que
                precisava de emissão de carteirinhas para os sócios e um
                controle de portaria.
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-th"
                    ></badge>
                    <h6 class="mb-0 text-white">Cadastro de sócios</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-usd"
                    ></badge>
                    <h6 class="mb-0 text-white">
                      Controle de receitas e despesas
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-unlock-alt"
                    ></badge>
                    <h6 class="mb-0 text-white">Controle de portaria</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="fa fa-file-o"
                    ></badge>
                    <h6 class="mb-0 text-white">Emissão de carteirinhas</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- texto  -->
    <!-- <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Build something</h2>
            <p class="lead text-white">
              According to the National Oceanic and Atmospheric Administration,
              Ted, Scambos, NSIDClead scentist, puts the potentially record low
              maximum sea ice extent tihs year down to low ice.
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon
              name="ni ni-settings"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Building tools</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-ruler-pencil"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Grow your market</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-atom"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Launch time</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
        </div>
      </div>
    </section> -->

    <!-- email -->
    <!-- <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Want to work with us?</h4>
              <p class="mt-0">Your project is very important to us.</p>
              <base-input
                class="mt-5"
                alternative
                placeholder="Your name"
                addon-left-icon="ni ni-user-run"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Email address"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
              </base-input>
              <base-button type="default" round block size="lg">
                Send Message
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section> -->

    <!-- habilidades & formação -->
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success">Algumas das minhas habilidades</span>
            </h2>
            <!-- <p class="lead">
              Cause if you do, it can be yours for FREE. Hit the button below to
              navigate to Creative Tim where you can find the Design System in
              HTML. Start a new project or give an old Bootstrap project a new
              look!
            </p> -->
            <div class="text-center">
              <div class="row justify-content-center align-items-center">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://vuejs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Vue.js - The progressive javascript framework"
                  >
                    <img
                      v-lazy="require('@/assets/images/vue.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://vuetifyjs.com/en/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Vuetify.js - The UI VueJS framework"
                  >
                    <img
                      v-lazy="require('@/assets/images/vuetify.png')"
                      width="75%"
                      class="img-fluid mt-2"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://getbootstrap.com/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Bootstrap 4 - Most popular front-end component library"
                  >
                    <img
                      v-lazy="require('@/assets/images/bootstrap.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://nodejs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/nodejs.png')"
                      width="100%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://dotnet.microsoft.com/apps/aspnet"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/netcore.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.postgresql.org/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/postgreSQL.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <!-- <div class="col-lg-2 col-4">
                  <a
                    href="https://www.mongodb.com/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/mongodb.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success">Formação</span>
            </h2>
            <span> bacharel em Sistemas de Informação pela FIPP - Unoeste</span>
            <div class="text-center">
              <div class="row justify-content-center align-items-center mt-5">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.unoeste.br/fipp/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/fipp.png')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.unoeste.br"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/unoeste.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
